module.exports = __webpack_public_path__ + "static/media/storytelling-3@2x.d7b83ea1.jpg";